 /*=========================================================================================
  File Name: mutations.js
  Description: Orders Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Orders  State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_ORDERS_STATE (state, payload) {
        state.ordersByDate = payload;
    },

    
}